import { render, staticRenderFns } from "./EditCamposSistema.vue?vue&type=template&id=f2af9f98&scoped=true"
import script from "./EditCamposSistema.vue?vue&type=script&lang=js"
export * from "./EditCamposSistema.vue?vue&type=script&lang=js"
import style0 from "./EditCamposSistema.vue?vue&type=style&index=0&id=f2af9f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2af9f98",
  null
  
)

export default component.exports